import UserMapMarker from './UserMapMarker';

export default UserMapMarker;
